<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZZQfNu/tc-custom/9781685502027.jpg?1723406932734" alt="This image is the cover for the book Stage Fright"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stage Fright
      </h1>
      <p class="bookDescription body article font2">
        <p>All the world's a stage, but Hell's Kitchen private detective Jimmy McSwain learns life upon its wicked boards can be a killer.<br/><br/>The Harold Calloway Theatre on West 47th Street is home to the new play <i>Triskaidekaphobia</i>, and its playwright has been receiving threatening messages. Theatre owner and lead producer Wellington Calloway has hired Jimmy to investigate, but it's a case not without its complications. His mother is the head usher, and Jimmy grew up on its aisles. His ex Remy is also the costume designer for the show, a man he hasn't seen in years. Further making his life difficult is the mysterious Seetha Assan, who is connected -- albeit tentatively -- to the case that forever haunts Jimmy: his own father's murder. She may just have the clue to help him finally solve the cold case.<br/><br/>As opening night looms, Jimmy finds himself involved in a nest of egos and personalities while seeking the missing Seetha. Toss in his on-again, off-again relationship with Captain Francis X. Frisano, and suddenly Jimmy's life is edging toward tragedy. That's when a murderer strikes, and suddenly nothing is pretend anymore. Life on the stage has turned all too real, and all too deadly. Just like on the mean streets of Manhattan.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adam Carpenter
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6da52686